import CounsellorList from "@modules/study/counsellor/counsellor_list";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import React from "react";

const Counsellers = ({ counsellor }) => {
  return (
    <LayoutMain
      title="Counsellers"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/counsellor-all`}
    >
      <CounsellorList counsellor={counsellor} />
    </LayoutMain>
  );
};

export default Counsellers;

export async function getServerSideProps({ params }) {
  let counsellor = [];

  try {
    const counsellorList = await API.get(`/counsellor`);

    if (counsellorList.isSuccess && counsellorList.data) {
      counsellor = counsellorList.data;
    }

    return {
      props: {
        counsellor,
      },
    };
  } catch (err) {
    return {
      props: {
        counsellor,
      },
    };
  }
}
